import { Typography } from '@mui/material';
import RelatorioTimeSheet from './TimeSheet';

const TimeSheet = () => {
  return (
      <RelatorioTimeSheet />
  );
};

export default TimeSheet;
